export const REQUEST_HANDLING_INSTRUCTIONS_MAX_LENGTH = 2000;
